import React from 'react';
import { Button, Col, Row } from 'components';
import { ArrowLeftIcon } from 'components/common/icons';
import { Details } from 'pages/admin/leads/lead/details';
import styles from './styles.module.scss';
import { TabNav } from './tabNav';
import { OriginalEmailLink } from './details/OriginalEmailLink';

export const Lead: React.FC = () => {
  return (
    <Row className={styles.lead}>
      <Col>
        <Button title={'Click to go back'} onClick={() => history.back()} type={'link'} icon={<ArrowLeftIcon />} />
      </Col>
      <Col className={styles.main_section}>
        <Row wrap={false}>
          <Col flex={'296px'}>
            <Row className={styles.left_banner}>
              <Col className={styles.details}>
                <Details />
              </Col>
              <OriginalEmailLink />
            </Row>
          </Col>
          <Col flex={'1'} className={styles.right_section}>
            <TabNav />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Lead;
